// extracted by mini-css-extract-plugin
export var billingAddress = "_xy-g";
export var contactInfo = "_xy-d";
export var customerInfoContainer = "_xy-c";
export var customerInfoContainerMobile = "_xy-h";
export var customerInfoRow = "_xy-a";
export var customerInfoSection = "_xy-b";
export var fullWidthDividerMobile = "_xy-i";
export var imageContainer = "_xy-1";
export var paymentMethod = "_xy-e";
export var priceText = "_xy-6";
export var priceTextMobile = "_xy-7";
export var product = "_xy-0";
export var productImage = "_xy-2";
export var productInfo = "_xy-4";
export var productMobile = "_xy-9";
export var productTitle = "_xy-8";
export var quantityBadge = "_xy-3";
export var quantityText = "_xy-5";
export var shippingAddress = "_xy-f";